// @ts-check
import 'angular-polyfills'
import $ from 'jquery'

// These imports are for the effort to inject react components via react2angular library
import { react2angular } from 'react2angular';
import EditErrorModal from './react/components/edit-shift-status-modals/EditErrorModal';
import EditSuccessModal from './react/components/edit-shift-status-modals/EditSuccessModal';
import EditShiftModal from './react/components/edit-shift-modal/EditShiftModal';
import ShiftDetails from './react/components/shift-details/ShiftDetails';
import CancelShiftModal from './react/components/cancel-shift-modal/CancelShiftModal';
import EndModifyAssignments from './react/components/edit-modify-assignments/EndModifyAssignments';
import EndAssignmentModal from './react/components/end-assignment-modal/EndAssignmentModal';
import ExtendAssignmentModal from './react/components/extend-assignment/ExtendAssignment';
import { JobOverlapModal } from "./react/components/job-overlap-modal/JobOverlapModal";

window.$ = $
window.jQuery = $

import angular from 'angular'
import router from 'angular-ui-router'
import 'angular-filter'
import 'angular-material/angular-material.css'
import './common.css'
import './adminTools.css'
import material from 'angular-material'
import 'angular-cookies'
import animate from 'angular-animate'
import messages from 'angular-messages'
import 'angular-moment'
import 'angular-simple-logger'
import { any } from 'ramda' // eslint-disable-line
import moment from 'moment-timezone'
import {permission, uiPermission} from 'angular-permission'
window.moment = moment
import 'ui-cropper'
import 'ngmap'
import 'angular-loading-bar'
import 'angular-tooltips'
import 'bc-angular-material-time-picker/dist/md-time-picker.css'
import ngTimePicker from 'bc-angular-material-time-picker'
import job from './components/job'
import api from './shared/api'
import { initalizeSentry } from './sentry.js';

initalizeSentry()

import Debug from 'debug'
window.Debug = Debug
const debug = Debug('app:app.js')

// Factories/services.
import shared from './shared'

// Main app controller/template
// import template from './app.html'
import template from './app.html'
import menu from './shared/menu/menu.html'
import controller from './app.controller'
// Components.
import login from './components/login'
import weekdays from './components/weekdays'
import support from './components/customer-support-button'
import crew from './components/crew'
import company from './components/company'
import calendar from './components/calendar'
import roster from './components/roster'
import workforce from './components/workforce'
import resume from './components/resume'
import analytics from './components/analytics'
import settings from './components/settings'
import payroll from './components/payroll'
import directDeposit from './components/direct-deposit'
import manageJobs from './components/manage-jobs'
import home from './components/worker-home'
import simulateErrors from './components/simulate-errors'
import uiMask from 'angular-ui-mask'
import certificationBadgeComponent from './component-templates/certification-badge'
import certificationIconComponent from './component-templates/certification-icon'
import shiftTileComponent from './component-templates/shift-tile'

import 'oclazyload'

import './components/job/angAccordion.js'
import 'angular-material-expansion-panel'
import 'angular-drag-and-drop-lists'
import 'angular-sanitize'
import 'ng-showdown'
import 'ng-embed'

require('angular-tooltips/dist/angular-tooltips.min.css')
require('angular-tooltips/dist/angular-tooltips.js')
import 'angular-socialshare'
import branch from 'branch-sdk' // eslint-disable-line
import ngclipboard from 'ngclipboard' // eslint-disable-line

import userRolesAndPermissions from './shared/userRolesAndPermissions'
import setTheme from './shared/setTheme'

import errorHandler, { captureSentryMessage } from './shared/errorHandler'
import { BEARER_TOKEN_NAME, JWT_TOKEN_NAME, TIMETRACKING_LEGACY_VIEW_SPLIT_NAME, WEB_V1_URL_LOCAL, WEB_V1_URL_PROD, WEB_V1_URL_STAGING } from './constants';
import CognitoUtils from './shared/cognitoUtils';
import { setUser } from '@sentry/browser';
import { decodeJWT } from './shared/utils';
import { LEGACY_API_V1_PATTERNS } from './app.interceptorPatterns';

angular.module('app', [
  'uiCropper',
  'ngSanitize',
  'ngCookies',
  'ngMessages',
  'angAccordion',
  'material.components.expansionPanels',
  'angularMoment',
  'angular-loading-bar',
  'angular.filter',
  'nemLogging',
  '720kb.tooltips',
  '720kb.socialshare',
  'ngMap',
  'oc.lazyLoad',
  'ngEmbed',
  'ngclipboard',
  'ngSegment',
  'ng-showdown',
  permission,
  uiPermission,
  ngTimePicker,
  calendar.name,
  workforce.name,
  resume.name,
  analytics.name,
  crew.name,
  login.name,
  roster.name,
  manageJobs.name,
  job.name,
  company.name,
  settings.name,
  payroll.name,
  directDeposit.name,
  shared.name,
  home.name,
  simulateErrors.name,
  weekdays.name,
  support.name,
  messages,
  animate,
  router,
  material,
  uiMask,
  'dndLists',
  certificationBadgeComponent.name,
  certificationIconComponent.name,
  shiftTileComponent.name,
])
.factory('$amplify', () => require('aws-amplify'))
.factory('$cognitoIdenty', () => require('amazon-cognito-identity-js'))
.factory('$exceptionHandler', () => errorHandler)
// Initializing React component for use throughout the application.
.component('editErrorModal', react2angular(EditErrorModal, ['cancel', 'message']))
.component('endModifyAssignments', react2angular(EndModifyAssignments, [
  'assignmentEndDate',
  'jobs',
  'onEndAssignment',
  'onExtendAssignment',
  'getShiftsCount',
  'user',
  'userCanPostJobs',
  'timezone',
]))
.component('editSuccessModal', react2angular(EditSuccessModal,
  [
  'cancel',
  'title',
  'bodyText',
  ]))
.component('editShiftModal', react2angular(EditShiftModal, ['staticProps', 'timeValidationError', 'fieldsEdited', 'onChange']))
.component('endAssignmentModal', react2angular(EndAssignmentModal, [
  'dropdownOptions',
  'onClose',
  'onEndAssignment',
  'user',
  'userJobs',
  'timezone',
]))
  .component('extendAssignmentModal', react2angular(ExtendAssignmentModal, [
  'onClose',
  'onExtendAssignment',
  'userJobs',
  'timezone',
]))
.component('cancelShiftModal', react2angular(CancelShiftModal, [
  'dropdownOptions',
  'onCancelShift',
  'onClose',
  'selectedUser',
  'shiftInProgress'
]))
.component('shiftDetails', react2angular(ShiftDetails, [
  'userCertificationIcons',
  'assignmentEndDate',
  'clockInOut',
  'clockInOutEnabled',
  'dontSendBack',
  'dsb',
  'formattedShiftDate',
  'formattedShiftTime',
  'handleFavorite',
  'isClockedIn',
  'isClockedOut',
  'isFavorite',
  'isUserDontSendBack',
  'markAbsent',
  'openCancelModal',
  'openEditShiftModal',
  'pastShift',
  'reactAppUrl',
  'selectedShift',
  'shiftStatus',
  'undoMarkAbsent',
  'userCanPostJobs',
  'userChat',
  'viewProfileRedirect',
  'showGroupMessage',
]))
.component('jobOverlapModal', react2angular(JobOverlapModal, ['cancel', 'message']))
.factory('authInterceptor', ($rootScope, $q, $window, $cookies) => {
  'ngInject'
  return {
    request: (config) => {

      // Requests for assets also get run through this, so
      // skip doing anything if the request is for an icon
      if (config.url.match(/(\.svg)$/)) return config;

      // --------------------------------------------------------
      // THIS IS A HACK !!!
      // 
      // Some api-v1 routes in prod take > 30 seconds to execute. This is an 
      // issue because the max timeout value you can have for api-gateway is 30
      // seconds; this is a hard limit that we cannot change.
      // 
      // In the short term, until the endpoints are sped up, we must bypass 
      // api-gateway and directly call the old domain with a legacy bearer 
      // token to avoid breaking web-angular. 
      //
      // See: https://ebpp.atlassian.net/browse/WC-44 for more details
      // 
      // TODO(WC-45): Remove slow endpoint workaround
      // --------------------------------------------------------
      // V1 endpoints that need to use legacy domain
      const legacyApiV1EndpointPathsList = LEGACY_API_V1_PATTERNS;

      const parsedUrl = new URL(config.url)

      const v1Matches = legacyApiV1EndpointPathsList.filter((pattern) => parsedUrl.pathname.match(pattern));
      const isV1SlowPath = v1Matches.length > 0;

      let useLegacyAuthentication = false;

      if (isV1SlowPath) {
        const modifiedUrl = new URL(parsedUrl.pathname, api.base)
        config.url = modifiedUrl.href
        useLegacyAuthentication = true;
      }
      // --------------------------------------------------------

      // Only add auth tokens to api requests, those all start with /.

      if (!CognitoUtils.getUserIsCrewMember()) {
        CognitoUtils.refreshCognitoSessionIfExpired()
      }
      
      const applyCognitoAuthentication = (config) => {
        const cognitoAuth = CognitoUtils.getCognitoAuth()
        const idToken = cognitoAuth.idToken;
        config.headers.Authorization = idToken;
      }

      /**
       * @param {{ url: string; headers: { Authorization: string; }; }} config 
       * @param {string} v1Token 
       * @param {string} v2Token 
       */
      const applyLegacyAuthentication = (config, v1Token, v2Token) => {
        if (config.url.startsWith(CONFIG.API_BASE) && !config.url.startsWith(CONFIG.API_BASE + '/noauth')) { // eslint-disable-line
          config.headers.Authorization = 'Bearer ' + v1Token
        }
        if (config.url.startsWith(CONFIG.API_BASE_V2)) { // eslint-disable-line
          config.headers.Authorization = 'JWT ' + v2Token
        }  
      }
      // Biller ONLY cares about 'v1-authorization' header
      if (config.url.startsWith(CONFIG.BILLER_API_ROOT)) {
        config.headers['v1-authorization'] = 'Bearer ' + $cookies.get(BEARER_TOKEN_NAME)
      } 
      // Apply 'other' authentication on any non-biller request
      else if (!useLegacyAuthentication) {
        applyCognitoAuthentication(config)
      } 
      else {
        applyLegacyAuthentication(
          config, 
          $cookies.get(BEARER_TOKEN_NAME),
          $cookies.get(JWT_TOKEN_NAME)
        )
      }

      // Add custom headers to request if web-angular is being run against a local copy of api-v1 or api-v2.
      // Web-ang + web-react now use cognito to authenticate users; Users send cognito id tokens with requuests.
      // Api-v1/v2 do not directly understand the id tokens, the api-gateways decode them and inject custom headers.
      // This code is essentialy replicating the behavior of the gateway to enable local development.
      // IMPORTANT: This runs AFTER legacy authentication to override bearer tokens when URL is localhost
      
      if (config.url.includes('localhost') && process.env.NODE_ENV === 'development') {
        config.headers.Authorization = undefined;
        let userExternalId = CognitoUtils.getUserExternalId();
        
        if (!userExternalId) {
          try {
            const cognitoAuth = CognitoUtils.getCognitoAuth();
            if (cognitoAuth && cognitoAuth.idToken) {
              const decodedIdToken = decodeJWT(cognitoAuth.idToken);
              
              if (decodedIdToken && decodedIdToken['custom:external_user_id']) {
                userExternalId = decodedIdToken['custom:external_user_id'];
              }
            }
          } catch (error) {
            debug('Failed to decode idToken:', error);
          }
        }

        if (userExternalId) {
          config.headers['x-user-id'] = userExternalId;
        }
        if (config.url.startsWith(CONFIG.COGNITO.Gateways.apiV1Url)) {
          config.headers['x-api-key'] = CONFIG.COGNITO.ApiKeys.apiV1;
        }
        if (config.url.startsWith(CONFIG.COGNITO.Gateways.apiV2Url)) { 
          config.headers['x-api-key'] = CONFIG.COGNITO.ApiKeys.apiV2;
        }
      }
      return config
    },
    responseError: (response) => {
      if (any(x => (response.status === x), [401, 403])) {
        debug('user unauthenticated')
        $rootScope.$broadcast('unauthenticated', response)
      }
      return $q.reject(response)
    }
  }
})
.run(['$window', '$location', function ($window, $location) {
  $window.addEventListener('message', function (event) {
    if (event.origin !== WEB_V1_URL_STAGING || event.origin !== WEB_V1_URL_PROD || event.origin !== WEB_V1_URL_LOCAL) return;
    if (event.data.key === 'X-Cognito-Token') {
      try {
        if (!event.data.value) {
          console.error('No token received from webView');
          return;
        }
        document.cookie = `X-Cognito-Token=${event.data.value}; path=/; secure; SameSite=Strict`;
      } catch (error) {
        console.error('Error setting Cognito token cookie:', error);
      }
    }
  });
}])
.run(['$rootScope', '$window', '$state', 'Auth', 'PermRoleStore', 'PermPermissionStore', '$urlRouter', '$location', 'segment', 'userConsent', '$amplify', '$cognitoIdenty', function ($rootScope, $window, $state, Auth, PermRoleStore, PermPermissionStore, $urlRouter, $location, segment, userConsent, $amplify, $cognitoIdenty) {
  'ngInject'
    
  const config = {...CONFIG.COGNITO.Auth,  
    cookieStorage: {
      domain: CONFIG.COOKIE_DOMAIN,
      path: "/",
      expires: 7,
      secure: !["", "localhost"].includes(CONFIG.COOKIE_DOMAIN),
    }
  }
  $amplify.Amplify.configure(config)

  if (Auth.loggedIn() && Auth.sessionIsValid()) {
    Auth.getDetails()
    .then((/** @type {import('./shared/auth.js').UserDetails} */ user) => {
      PermRoleStore.defineManyRoles(userRolesAndPermissions.getRoleDefinitions(user))
      userRolesAndPermissions.definePermissions(user, PermPermissionStore)

      // Add user identifiers to the current sentry context
      setUser({email: user.username, id: user.id});
    })
    .then(() => {
      // Once permissions are set-up
      // kick-off router and start the application rendering
      $urlRouter.sync()
      // Also enable router to listen to url changes
      $urlRouter.listen()
    })
  } else if (Auth.loggedIn() && !Auth.sessionIsValid()) {
    CognitoUtils.refreshCognitoSessionIfExpired()
  } else {
    PermRoleStore.defineManyRoles(userRolesAndPermissions.getRoleDefinitions())
    if ($location.$$path.includes('/reset')) {
      if (!$location.search().auth) {
        captureSentryMessage('Reset password triggered without auth token');
        console.debug('[DEBUG] $state.go(app.login) triggered by /reset without auth');
        $state.go('app.login')
      }
      let tempAuthToken = $location.search().auth
      captureSentryMessage('[DEBUG] $state.go(app.reset) triggered by /reset');
      console.debug('[DEBUG] $state.go(app.reset) triggered by /reset');
      $state.go('app.reset', {auth: tempAuthToken})
    } else if ($location.$$path.includes('/activate')) {
      if (!$location.search().auth) {
        captureSentryMessage('[DEBUG] $state.go(app.login) triggered by /activate without auth');
        console.debug('[DEBUG] $state.go(app.login) triggered by /activate without auth');
        $state.go('app.login')
      }
      let tempAuthToken = $location.search().auth
      captureSentryMessage('[DEBUG] $state.go(app.activate) triggered by /activate');
      console.debug('[DEBUG] $state.go(app.activate) triggered by /activate');
      $state.go('app.activate', {auth: tempAuthToken})
    } else if ($location.$$path.includes('/login/worker')) {
      if ($location.$$path.includes('/login/worker/')) {
        let pipleineId = $location.$$path.substring(14, 24)
        captureSentryMessage('[DEBUG] $state.go(app.login) triggered by /login/worker/');
        console.debug('[DEBUG] $state.go(app.login) triggered by /login/worker/');
        $state.go('app.login', {create: 'worker', pipeline: pipleineId})
      } else {
        captureSentryMessage('[DEBUG] $state.go(app.login) triggered by /login/worker');
        console.debug('[DEBUG] $state.go(app.login) triggered by /login/worker');
        $state.go('app.login', { create: 'worker', email: $location.search().email || null, stageid: $location.search().stageid || null, companyeor: $location.search().companyeor || null })
      }
    } else if ($location.$$url === '/login/company') {
      captureSentryMessage('[DEBUG] $state.go(app.login) triggered by /login/company');
      console.debug('[DEBUG] $state.go(app.login) triggered by /login/company');
      $state.go('app.login', {create: 'company'})
    } else {
      captureSentryMessage('[DEBUG] $state.go(app.login) triggered by default else');
      console.debug('[DEBUG] $state.go(app.login) triggered by default else');
      $state.go('app.login')
    }
  }
  $rootScope.loader = true
  // Intercom boot moved to app.controller.js to include JWT authentication
  $rootScope.goBack = () => {
    $window.history.back()
  }

  $rootScope.$on('unauthenticated', (response) => {
    if (!$state.is('app.login') && !$state.is('app.inboundCreate')) {
      $state.go('app.login');
    }
  })
 
  /**
   * A custom 'do not show the loader' event.
   */
  $rootScope.$on('app:skipLoader', (response) => {
    debug('skip loading indicator')
    $rootScope.loader = false
  })

  $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
    debug('Moving from %o to %o', fromState, toState)
    if (fromState.parent === toState.name) return event.preventDefault()
    if (Auth.me && Auth.me.beta_active) {
      const positionsUrl = `${CONFIG.REACT_APP_BASE}/positions`
      const postJobUrl = `${CONFIG.REACT_APP_BASE}/jobs/post`

      // V2 redirect
      if (toState.name === 'app.jobs') $window.location.href = positionsUrl // eslint-disable-line
      if (toState.name === 'app.jobCreate') {
        let locationHref = postJobUrl // eslint-disable-line
        // toParams for crewsOnly and Direct Hires
        // if (toParams) let workerExternalIds = prop('directlyInvitedWorkers', toParams)
        // if (workerExternalIds)
        if (toParams && toParams.directlyInvitedWorkers) {
          const workerExternalIds = toParams.directlyInvitedWorkers.map(
            worker => worker.external_id
          )
          const qString = JSON.stringify(workerExternalIds)
          locationHref = `${postJobUrl}?directInviteUserIds=${qString}` // eslint-disable-line
        }
        if (toParams && toParams.crewForHire) {
          const crewForHireIds = toParams.crewForHire.map(
            (crew) => crew.id
          )
          const qString = JSON.stringify(crewForHireIds)
          locationHref = `${postJobUrl}?crewForHireIds=${qString}` // eslint-disable-line
        }
        $window.location.href = locationHref
      }

      if (toState.name === 'app.settings.info') $window.location.href = `${CONFIG.REACT_APP_BASE}/settings/company`
    }

    if (fromState.name === 'app.jobCreate.step1' && toState.name === 'app.jobCreate') {
      return event.preventDefault()
    }

    if (fromState.name === 'app.reset' && toState.name === 'app.login') {
      $state.transition.cancel();
    }

    /**
     * A little logic to not show loader on transitions to states without
     * resolves, or a child state going to a parent. Supports an override
     * variable to hide the loader.
     */
    // let hasResolves = (!isEmptyIsh(toState.resolve))
    // let isParentState = toState.name === fromState.parent
    // let canShowLoader = (hasResolves && !isParentState && fromState.name !== 'app.login')

    // if (canShowLoader) $rootScope.$broadcast('app:loading:start')
    if (fromState.name === 'app.login' && Auth.loggedIn()) {
      Auth.getDetails()
      .then(user => {
        userRolesAndPermissions.definePermissions(user, PermPermissionStore)
        PermRoleStore.defineManyRoles(userRolesAndPermissions.getRoleDefinitions(user))
      })
    }
    if (toState.authenticate && !Auth.loggedIn() && !$state.is('app.login', {create: 'worker'}) && !$state.is('app.login', {create: 'company'})) {
      debug('user not authenticated')
      PermRoleStore.clearStore()
      $state.go('app.login')
      event.preventDefault()
    }
  })

  $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
    if (!Auth.me.isWorker) {
      segment.page(toState.name)
    }
    $rootScope.$broadcast('app:loading:done')
  })

  userConsent.initialize();
}])
.constant('moment', require('moment-timezone'))
.config(($httpProvider, $urlRouterProvider, $stateProvider, $mdThemingProvider,$mdInkRippleProvider, $mdIconProvider, segmentProvider, $mdDateLocaleProvider) => {
  'ngInject'
  
  $urlRouterProvider.deferIntercept()
  // $locationProvider.html5Mode(true)
  // $locationProvider.hashPrefix('')
  // $permissionProvider.setDefaultOnAuthorizedMethod('attachElement')
  // $permissionProvider.setDefaultOnUnauthorizedMethod('detachElement')
  segmentProvider
    .setKey(CONFIG.SEGMENT_KEY) // eslint-disable-line
    .setDebug(CONFIG.IS_PROD ? false : true) // eslint-disable-line
    // .setCondition({integrations: { 'Pendo': false }})
    // .setAutoload(false)
  setTheme($mdThemingProvider)
  $mdInkRippleProvider.disableInkRipple()
  $urlRouterProvider.otherwise('/login')
  $mdIconProvider.iconSet('skills-fonts', 'bluecrew-skills/style.css', 24)

  $stateProvider.state('app', {
    abstract: true,
      // url: '/{_branch_match_id:int}',
      // params: {
      //   _branch_match_id: {value: null, squash: true}
      // },
    views: {
      menu: {
        template: menu
      },
      '': {
        template: template,
        controller: controller,
        controllerAs: 'app'
      }
    }
  })
  $httpProvider.interceptors.push('authInterceptor')
})
